import React from 'react';
import '../../styles/sass/_About.css';
import { Grid, Row, Col } from "react-bootstrap";
import SideBar from '../SideBar';
import Menu from "../Menu";
import { FirstInfoSection } from "./SectionInfo";
import { connect } from 'redux-zero/react';


const About = ({ isSpanish }) => {
    return (
        <Col lg={9} md={9} className='about__container'>
            <Menu isSpanish={isSpanish} />
            <FirstInfoSection isSpanish={isSpanish} />
        </Col>
    )
}

const AboutView = ({ isSpanish }) => {
    return (
        <Grid fluid>
            <Row>
                <SideBar />
                <About isSpanish={isSpanish} />
            </Row>
        </Grid>
    )
}


//export default AboutView;
const mapToProps = ({ isSpanish }) => ({ isSpanish });
export default connect(mapToProps)(AboutView);


// WEBPACK FOOTER //
// ./src/components/About/About.js